import { render } from "./panel.vue?vue&type=template&id=896d24e0&scoped=true"
import script from "./panel.vue?vue&type=script&lang=ts"
export * from "./panel.vue?vue&type=script&lang=ts"

import "./panel.vue?vue&type=style&index=0&id=896d24e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-896d24e0"

export default script